import { SortType } from  "@/interfaces/lists";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";
import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { CombinedFeedSortType } from  "@/interfaces/CombinedFeed";
import { IContentSearchResult, ParentContent, ParentContentQueryParams } from  "@/interfaces/content";


const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getAllMenuItems(appId: string, listId: string, top: number, skip: number, viewMyItems: boolean): Promise<any> {
    const url = viewMyItems 
        ?   `app/${appId}/list/${listId}/content?filters[0]=CanEdit&top=${top}&skip=${skip}` 
        :   `app/${appId}/list/${listId}/content?&top=${top}&skip=${skip}`;
    
    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get menu items list`))
}

export function getSortTypeFromEnum(sortType: SortType | CombinedFeedSortType){
    
    switch (sortType) {
            case SortType.DateCreatedNewest:
                return 'DateCreatedNewest'
            case SortType.DateCreatedOldest:
                return 'DateCreatedOldest';
            case SortType.DateModifiedNewest:
                return 'DateModifiedNewest';
            case SortType.DateModifiedOldest:
                return 'DateModifiedOldest';
            case SortType.TitleAZ:
                return 'AlphabeticalAZ';
            case SortType.TitleZA:
                return 'AlphabeticalZA';
            case SortType.Manual:
                return 'Manual';
            default:
                return undefined
        }
}

export function getEnumFromSortTypeString(sortTypeString: string){
    switch (sortTypeString) {
        case 'DateCreatedNewest':
            return SortType.DateCreatedNewest
        case 'DateCreatedOldest':
            return SortType.DateCreatedOldest;
        case 'DateModifiedNewest':
            return SortType.DateModifiedNewest;
        case 'DateModifiedOldest':
            return SortType.DateModifiedOldest;
        case 'AlphabeticalAZ':
            return SortType.TitleAZ;
        case 'AlphabeticalZA':
            return SortType.TitleZA;
        case 'Manual':
            return SortType.Manual;
        default:
            return undefined
    }
}

export async function getAllListItems(appId: string, listId: string, top: number, skip: number, viewMyItems: boolean, currentSort: SortType | CombinedFeedSortType, signal?: AbortSignal): Promise<any> {
    const sort =  getSortTypeFromEnum(currentSort);

    const url = viewMyItems 
        ?   `app/${appId}/list/${listId}/content?filters[0]=CanEdit&top=${top}&skip=${skip}&sortType=${sort}` 
        :   `app/${appId}/list/${listId}/content?top=${top}&skip=${skip}&sortType=${sort}`;
    
    const res = await http.get(url, {signal});
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get content items list`))
}

export async function moveItem(listId: string, itemId: string, payload:{toPosition: number}) {
    const res = await http.put(`list/${listId}/moveitem/${itemId}`, payload);

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't update item position change`))
}

export async function removeItem(listId: string, itemId: string) {
    const res = await http.delete(`list/${listId}/removeitem/${itemId}`);

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't archive content item`))
}

export async function getExistingContent(appGuid: string, listId: string, position: 'start' | 'end'){
    const res = await http.get(`../a/${appGuid}/Content/SearchExistingContent?parentId=${listId}&position=${position}`);

    if(res.data) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(new Error(`Couldn't get existing content data`));
}

export async function getParentContents(contentId: string, options?:ParentContentQueryParams):Promise<PaginatedResponse<ParentContent>> {
    const res = await http.get(`content/${contentId}/GetParentContent`,  {params: options || {}});

    if(res.data) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(new Error(`Couldn't get existing content data`));
}

export async function searchContent(appGuid: string, searchTerm: string, skip: number, options?: { signal?: AbortSignal }): Promise<IContentSearchResult> {
    const params = new URLSearchParams({
        "SearchTerm": searchTerm,
        "ContentStatuses[0]": "Published",
        "ContentStatuses[1]": "Draft",
        "boostedIetfLanguageTag": "en",
        "skip": String(skip),
        "LanguageFilters[0]":"en-GB"
    });

    const res = await http.get(`search/app/${appGuid}/content?${params.toString()}`, {signal: options?.signal});
    if (res.data) {
        return Promise.resolve(res.data);
    }
    return Promise.reject(new Error(`Couldn't get existing content data`));
}

export async function getMainMenuId(appId: string):Promise<any> {
    const res = await http.get(`app/${appId}/mainmenuid`);

    if(res.data) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(new Error(`Couldn't get main menu id`));
}

export async function duplicateContentInList(appId: string, contentId: number, listId: number):Promise<any> {
    const res = await http.post(`app/${appId}/Content/${contentId}/duplicate`, {TargetListId: Number(listId)});
    
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`There was a problem duplicating the content. Please try again.`));
}